export const myApplicationTranslations = {
  lv: {
    title: 'Mani pieteikumi',
    description:
      'Tavi aktīvie pieteikumi vakancēm. Atsauktie un noraidītie pieteikumi šeit netiek rādīti.',
    count_zero: '{{count}} pieteikumu',
    count_one: '{{count}} pieteikums',
    count_other: '{{count}} pieteikumi',
    vacancyGone: 'Vakance vairs nav pieejama',
    empty: 'Nav aktīvu pieteikumu',
    columns: {
      vacancy: 'Vakance',
      org: 'Organizācija',
      description: 'Motivācija',
      sent: 'Nosūtīts',
      owner: 'Kontaktpersona',
    },
  },
  en: {
    title: 'My applications',
    description:
      'Your active applications for vacancies. Withdrawn and declined applications are not shown here.',
    count_one: '{{count}} application',
    count_other: '{{count}} applications',
    vacancyGone: 'The vacancy is no longer available',
    empty: 'No active applications',
    columns: {
      vacancy: 'Vacancy',
      org: 'Organization',
      description: 'Motivation',
      sent: 'Sent',
      owner: 'Contact person',
    },
  },
}
